// extracted by css-extract-rspack-plugin
export default {"card":"ImageGeneration-module__card--I9OOz","description":"ImageGeneration-module__description--Lac1o"};